import React from "react";

export function AppSection({
    title,
    description,
    action,
    children,
    className = "",
    testId,
}) {
    return (
        <section
            data-testid={testId}
            className={`px-4 py-6 sm:py-8 ${className}`}
        >
            {(title || action) && (
                <div className="mb-4 flex items-start justify-between gap-3">
                    <div className="min-w-0">
                        {title && (
                            <h2 className="md-h3 text-md-text">{title}</h2>
                        )}
                        {description && (
                            <p className="mt-1 text-sm text-md-text-2">{description}</p>
                        )}
                    </div>
                    {action && <div className="shrink-0">{action}</div>}
                </div>
            )}
            {children}
        </section>
    );
}

export default AppSection;
